var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ready
    ? _c(
        "div",
        _vm._l(_vm.data, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "form-row",
              on: {
                click: function($event) {
                  return _vm.clickAtSingleList(index)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "mb-2",
                  class: {
                    "col-md-6": !_vm.disabled,
                    "col-md-5": _vm.disabled
                  },
                  staticStyle: { height: "38px" }
                },
                [
                  _c("div", { staticClass: "d-flex" }, [
                    _vm.showProductImage
                      ? _c("img", {
                          staticStyle: {
                            "margin-right": "10px",
                            "border-radius": ".25rem"
                          },
                          attrs: {
                            src: _vm.productImage(item.sku_id),
                            width: "35",
                            height: "35"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { flex: "1" } },
                      [
                        [
                          !_vm.disabled &&
                          _vm.changeSkuAble &&
                          !item.disabledSku
                            ? _c("selectize", {
                                attrs: {
                                  updateoption: item.selectize.updateOption,
                                  options: _vm.optionSkus,
                                  default: item.sku_id,
                                  multiple: false,
                                  create: _vm.createAble,
                                  loading: item.selectize.loading,
                                  validation: item.selectize.trickValidation,
                                  placeholder: _vm.createAble
                                    ? _vm.$t("placeholder.selectorcreate")
                                    : _vm.$t("placeholder.selectitem")
                                },
                                on: { pick: _vm.onPickedSku },
                                model: {
                                  value: item.sku_id,
                                  callback: function($$v) {
                                    _vm.$set(item, "sku_id", $$v)
                                  },
                                  expression: "item.sku_id"
                                }
                              })
                            : _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  disabled:
                                    _vm.disabled ||
                                    !_vm.changeSkuAble ||
                                    item.disabledSku,
                                  type: "text"
                                },
                                domProps: {
                                  value: _vm.getSku(item.sku_id)
                                    ? _vm.getSku(item.sku_id).product_name
                                    : null
                                }
                              })
                        ]
                      ],
                      2
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-2 mb-2" }, [
                _c("div", { staticClass: "input-group" }, [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v(
                        _vm._s(_vm.$t("apps.inventory.label.serialnumber"))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.serial_number,
                        expression: "item.serial_number"
                      }
                    ],
                    staticClass:
                      "form-control text-right number-only text-select-all",
                    class: [
                      {
                        "is-invalid":
                          _vm.validation > 0 &&
                          ("" + item.serial_number).trim().length == 0
                      }
                    ],
                    attrs: {
                      disabled:
                        item.sku_id.length == 0 ||
                        _vm.disabled ||
                        item.disabledSer,
                      type: "text",
                      placeholder: ""
                    },
                    domProps: { value: item.serial_number },
                    on: {
                      change: function($event) {
                        return _vm.handleSerChange($event, item, index)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(item, "serial_number", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-2 mb-2" }, [
                _c("div", { staticClass: "input-group" }, [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v(_vm._s(_vm.$t("message.cost")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: item.cost,
                        expression: "item.cost"
                      }
                    ],
                    staticClass:
                      "form-control text-right number-only text-select-all",
                    attrs: {
                      disabled:
                        item.sku_id.length == 0 ||
                        _vm.disabled ||
                        item.disabledCost,
                      type: "text",
                      placeholder: ""
                    },
                    domProps: { value: item.cost },
                    on: {
                      keypress: _vm.numberOnly,
                      keyup: function($event) {
                        item.cost = _vm.setToValidNumber(item.cost)
                      },
                      blur: function($event) {
                        item.cost = _vm.setToCustomDigitsNumber(item.cost)
                      },
                      change: function($event) {
                        return _vm.handleCostChange($event, item, index)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(item, "cost", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43ca5134", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43ca5134","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/OrderSerial.vue
// module id = null
// module chunks = 